import { render } from "./chevron-up.vue?vue&type=template&id=7112d77e"
import script from "./chevron-up.vue?vue&type=script&lang=js"
export * from "./chevron-up.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__